import React from "react";
import { twMerge } from "tailwind-merge";
import { m } from "framer-motion";
import SLOT_STATUS from "constants/slot-status";

export default function CodeGridItem({
  children,
  status,
  opacity = 0.8,
  ...props
}) {
  const gridSlotVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity,
    },
  };

  return (
    <m.li
      variants={gridSlotVariants}
      {...props}
      className={twMerge(
        " opacity-80",
        props.className,
        "bg-indigo-600 py-1 rounded text-center font-bold transition-colors duration-500 ease-in-out flex justify-center items-center",
        status === SLOT_STATUS.SUCCESS &&
          "bg-green-600 border border-indigo-50",
        status === SLOT_STATUS.FAIL && "bg-red-600 border border-indigo-50"
      )}
    >
      {children}
    </m.li>
  );
}
